module.exports = __webpack_public_path__ + "static/media/CIMG3416.25ef9a67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_bei_den_Umzuegen/thumb/CIMG3416.jpg
// module id = 423
// module chunks = 0